export const getHighlightsSummary = state => state.highlightSummary;

export const getHighlightsSummaryForVbid = (state, isbn) => {
  return getHighlightsSummary(state).summary[isbn];
};

export const isFetchingHighlightsSummary = state => {
  return getHighlightsSummary(state).isFetching;
};

export const isLoadedHighlightsSummary = state => {
  return getHighlightsSummary(state).isLoaded;
};
